export var APPLICATION_NAME = '@ori/product-info-dialog-lib';
export var BUY_BUTTON_STATE_DEFAULT = 'default';
export var BUY_BUTTON_STATE_LOADING = 'loading';
export var DIALOG_MODE_FAVORITES = 'favorites';
export var DIALOG_MODE_LOADING = 'loading';
export var DIALOG_MODE_REWARDS_SHOP = 'rewardsShop';
export var DIALOG_MODE_STANDARD_BUY = 'standardBuy';
export var FAVORITES_BUTTON_STATE_IN = 'in';
export var FAVORITES_BUTTON_STATE_OUT = 'out';
export var FETCH_MODE_EAGER = 'eager';
export var FETCH_MODE_LAZY = 'lazy';
export var QUICK_BUY_BUTTON_STATE_DEFAULT = 'default';
export var QUICK_BUY_BUTTON_STATE_ERROR = 'error';
export var QUICK_BUY_BUTTON_STATE_LOADING = 'loading';
export var QUICK_BUY_BUTTON_STATE_SUCCESS = 'success';
export var QUICK_BUY_BUTTON_STATE_WAITING = 'waiting';
export var PRODUCT_INITIAL_QUANTITY = 1;